var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-loading"},[_vm._t("default"),_c('transition',{attrs:{"name":"anim-loader"}},[(_vm.$store.state.general.loaderName.includes(_vm.loaderName))?_c('Loader',{attrs:{"size":_vm.size}}):_vm._e()],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }